// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.75 4.33594L14.4142 12.0002L6.75 19.6644V4.33594ZM17.5 5.00015V19.0002H15.5V5.00015H17.5Z"}}]};

const NextFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'next-filled',
    ref,
    icon: element,
  },
));

NextFilledIcon.displayName = 'NextFilledIcon';

export default NextFilledIcon;
